import { render } from "./EmailsMenu.vue?vue&type=template&id=1bc5690e"
import script from "./EmailsMenu.vue?vue&type=script&lang=js"
export * from "./EmailsMenu.vue?vue&type=script&lang=js"

import "./EmailsMenu.vue?vue&type=style&index=0&id=1bc5690e&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__